module.exports = __webpack_public_path__ + "components/country-flag/static/kz-ad1814e1456c0b6447ce80f28f87ff53.svg";